module.exports = __webpack_public_path__ + "static/media/map-not-available.0ac287c2.png";